import { type TextStyles } from '#app/theme/textStyles.js';
import { Subheader } from './Modal.styles.js';
import { type HTMLAttributes } from 'react';

type ModalSubheaderProps = HTMLAttributes<HTMLParagraphElement> & {
  readonly textAlign?: 'center' | 'left' | 'right';
  readonly textStyle?: TextStyles;
};

const ModalSubheader = ({
  children,
  textAlign,
  textStyle = 'bodySmall',
}: ModalSubheaderProps) => {
  return (
    <Subheader
      textAlign={textAlign}
      textStyle={textStyle}
    >
      {children}
    </Subheader>
  );
};

ModalSubheader.displayName = 'Modal.Subheader';

export { ModalSubheader };
